<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">佣金设置</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-list">
            <a-divider orientation="left">
            佣金设置
            </a-divider>
            <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 6 }">
                <a-form-item label="签收（佣金）">
                    <a-input v-model="detail.money" prefix="￥" suffix="元" />
                </a-form-item>
                <a-form-item label="激活（佣金）">
                    <a-input v-model="detail.money1" prefix="￥" suffix="元" />
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 6, offset: 3 }">
                    <a-button type="primary" @click="tocost">
                        确定
                    </a-button>
                </a-form-item>
            </a-form>
           
            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            detail:""
        }
    },
    mounted(){
        this.costdetail()
    },
    methods:{
        costdetail(){
            this.$axios.post('/api/kefu/setcustomercommissionpage',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.detail=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 佣金设置
        tocost(){
            this.$axios.post('/api/kefu/editsetcustomercommission',{
                money:this.detail.money,
                money1:this.detail.money1
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.costdetail()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/setcost.vue